//
import { mapActions, mapState } from 'vuex'
import { ModelForm } from '@/components/reusable_components/next'

//
import OrdererModel from '@/models/Warehouse/WhOrderer'
import ProductModel from '@/models/Warehouse/WhProduct'
import Translator from '@/services/translator'
import fields from './fields'
import CurrencyUtils from '@/mixins/reusable_mixins/CurrencyUtils'

//
export default {
    name: 'orderer-process',
    components: {
        'model-form': ModelForm,
    },
    mixins: [CurrencyUtils],
    computed: {
        //
        ...mapState('AuthModule', ['user']),

        /**
         *
         */
        fieldsProps() {
            return {
                g_branch_office_id: this.user.hr_employee.g_branch_office_id,
                pch_provider_id: this.pch_provider_id,
                pch_provider_id_trigger: this.tggFormDataBranchOffice,
                pch_provider_branch_offices_id_items: this.formDataBranchOffices,
            }
        },

        /**
         *
         */
        formProps() {
            return {
                fields: fields(this.fieldsProps),
                loading: this.busy,
            }
        },

        /**
         *
         */
        pch_provider_id() {
            return this.formData.pch_provider_id
        },

        /**
         *
         */
        totals() {
            let exent = this.formData.is_exent
            let totals = this.formData.wh_selected_products.reduce(
                ({ netTotal, units }, product) => {
                    units += parseFloat(product.quantity)
                    netTotal +=
                        parseFloat(product.quantity) *
                        parseFloat(product.net_price)
                    return { netTotal, units }
                },
                { netTotal: 0, units: 0 }
            )
            totals.total = Math.round(totals.netTotal * (exent ? 1 : 1.19))
            totals.iva = (totals.netTotal * (exent ? 0 : 0.19)).toFixed(2)
            totals.netTotal = totals.netTotal.toFixed(2)
            return totals
        },
    },
    data() {
        return {
            busy: false,
            formData: {},
            formDataBranchOffices: [],
        }
    },
    methods: {
        //
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),

        //
        ...mapActions('SnackbarModalModule', {
            setErrorSnackbar: 'setErrorSnackbar',
            setSuccessSnackbar: 'setSuccessSnackbar',
        }),

        /**
         *
         */
        fetch() {
            OrdererModel.modeler()
                .find(this.$route.params.id)
                .then(this.setFormData)
        },

        /**
         *
         */
        process(model) {
            model
                .process()
                .save()
                .finally(this.$refs.form.setWait)
                .then(this.showSuccess)
                .then(this.redirect)
                .catch(this.showError)
        },

        /**
         *
         */
        redirect() {
            this.$router.push({ name: 'purchase-order-pending' })
        },

        /**
         *
         */
        reset() {
            this.busy = !this.fetch()
        },

        /**
         *
         */
        setFormData(model) {
            //
            this.busy = false

            this.formData = model.clone().reset()

            //
            this.formData.wh_detail_orderers.forEach(item => {
                ProductModel.append('branch_offices')
                    .find(item.wh_product_id)
                    .then(this.setProductPrice)
            })
        },

        /**
         *
         */
        setProductPrice(model) {
            //
            const formDataSelectedIndex = this.formData.wh_selected_products.findIndex(
                item => item.wh_product_id === model.id
            )
            //
            this.formData.wh_selected_products[
                formDataSelectedIndex
            ].net_price = model.toDetailPurchaseOrder(
                this.fieldsProps
            ).net_price
        },

        /**
         *
         */
        showError(error) {
            this.setErrorSnackbar(Translator(OrdererModel, error.response.data))
        },

        /**
         *
         */
        showSuccess() {
            this.setSuccessSnackbar('Orden de compra creada.')
        },

        /**
         *
         */
        submit() {
            this.$refs.form.setWait(true).then(this.process)
        },

        /**
         * @description
         */
        tggFormDataBranchOffice(ctx) {

            //
            const fieldset = ctx.getFieldset()
            const { branch_offices } = ctx.getInput('pch_provider_id').getSelected()

            // set new items
            this.formDataBranchOffices = branch_offices || []

            // reset fieldset
            fieldset.$forceUpdate()
        },
    },
    beforeMount() {
        this.setTitleTopBar('Procesar solicitud de abastecimiento')
    },
    mounted() {
        this.reset()
    },
}
